import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import { Spinner } from 'construct-ui';
import { v4 as uuidv4 } from 'uuid';
import { messageComponent } from '../../../components/message/message.component';
import { staticUrls } from '../../../config/constants';
import announcementModel from '../../../models/announcement/announcement.modal';
import ViewBase from '../../view-base.view';
import AnnouncementRecipientView from './announcement-recipent-list.view';

export default function AnnouncementDetailView() {
    ViewBase.call(this);
    let onStatusChange = (e) => { };
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let selectedFileList = "";
    let showCheckedAll = true;
    let announcementId = "";
    let detailType = "";
    let announcementDetails = [];
    let announcementFiles = [];
    let files = [];
    let data = [];
    let isActive = 'Y';
    let countFont = "";

    let onTypeChanged = (e) => {
        detailType = e;
    };

    let _checkAll = () => {
        files.forEach(function (element) {
            element.checked = true;

        });
        showCheckedAll = false;
    }

    let _unCheckAll = () => {
        files.forEach(function (element) {
            element.checked = false;

        });
        showCheckedAll = true;
    }

    let _download = () => {
        isLoading = true;
        selectedFileList = "";
        let _arr = [];

        let _fileName = uuidv4();
        files.forEach(function (element) {
            if (element.checked) {
                _arr.push(element.fileId);
            }
            selectedFileList = _arr.join(',');
        });
        if (_arr.length > 0) {
            announcementModel.downloadZip(
                (result) => {
                    isLoading = false;
                },
                (error) => {
                    isLoading = false;
                    this.handleError(error);
                },
                selectedFileList, _fileName
            )
        }
        else {
            isLoading = false;
            isMsgOpen = true;
            showMsg = this.getText("EM00000192", "Please select files to download");;
            msgTitle = this.getText("EM00000142", "Error");
        }
    }

    let _loadAnnouncementDetails = (announcementId) => {
        isLoading = true;
        announcementModel.getUserDetails(
            (result) => {
                isLoading = false;
                announcementDetails = result["announcementIDDetails"][0];
                announcementFiles = result["announcementIDFileDetails"];
                isActive = announcementDetails["statusName"] === "Active" ? "Y" : "N";
                data = [{
                    type: "Read",
                    value: announcementDetails["readCount"]
                }, {
                    type: "Unread",
                    value: announcementDetails["unreadCount"]
                }];
                announcementFiles.forEach(function (file) {
                    files.push({ name: file.originalFileName, fileId: file.fileMasterID, checked: false });
                });
                let count = announcementDetails["readCount"].toString().length > announcementDetails["unreadCount"].toString().length ? announcementDetails["readCount"].toString().length : announcementDetails["unreadCount"].toString().length;
                if (count == 1 || count == 2) {
                    countFont = "28pt";
                }
                else if (count == 3) {
                    countFont = "26pt";
                }
                else if (count == 4) {
                    countFont = "18pt";
                }
                else if (count == 5) {
                    countFont = "14pt";
                }
                else {
                    countFont = "12pt";
                }
                _loadPieChar();
            },
            (error) => {
                isLoading = false;
                this.handleError(error);
            },
            announcementId
        )
    }

    let _loadPieChar = () => {
        let root = am5.Root.new("chartdiv");

        // Formatter
        root.numberFormatter.set("numberFormat", "#,###");

        // Themes
        root.setThemes([
            am5themes_Responsive.new(root),
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(
            am5percent.PieChart.new(root, {})
        );
        // Create series
        var series = chart.series.push(
            am5percent.PieSeries.new(root, {
                name: "Series",
                valueField: "value",
                categoryField: "type",
                alignLabels: false,
                radius: am5.percent(90),
                innerRadius: am5.percent(60),
            })
        );
        // series.ticks.template.set("visible", false);
        series.get("colors").set("colors", [
            am5.color(0x1428A0),
            am5.color(0xFE4335)
        ]);
        series.data.setAll(data);

        let totalLabel = root.tooltipContainer.children.push(am5.Label.new(root, {
            x: am5.percent(50),
            y: am5.percent(53),
            centerX: am5.p50,
            centerY: am5.p50,
            fill: am5.color(0x000000),
            fontSize: 12,
            textAlign: "left"
        }));
        totalLabel.set("text", "[fontSize: 12px]Read: [bold]" + data[0].value + "[/]\n[fontSize: 12px]Unread: [bold]" + data[1].value + "[/][/]");
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    return {
        oninit: function (vnode) {
            if (vnode.attrs.onStatusChange) {
                onStatusChange = vnode.attrs.onStatusChange;
            }
            if (vnode.attrs.announcementId) {
                announcementId = vnode.attrs.announcementId
            }

            _loadAnnouncementDetails(announcementId);
        },
        view: (vnode) => {
            return [m(Spinner, {
                active: isLoading,
                background: true,
                fill: true,
                size: 'xl',
            }),
            m('.row',
                m('col-md-12',
                    m('h4.ps-2', announcementDetails.title),
                    m('.card',
                        m('.card-body.pb-0',
                            m('.row',
                                m('.col-4.pe-0',
                                    m('.card',
                                        m('.row',
                                            m('.col-sm-7.pe-0',
                                                m("#chartdiv.ac-container-hide-logo", { style: "height: 200px; width:170px; margin:0 auto;" }),
                                            ),
                                            m('.col-sm-5.ps-0',
                                                m('.detailHeader', {
                                                    onclick: () => {
                                                        onTypeChanged('');
                                                    }
                                                }, this.getText("LT00000046", "Total")),
                                                m('.detailNumber', {
                                                    onclick: () => {
                                                        onTypeChanged('');
                                                    }
                                                }, m('label.mt-8', Number(announcementDetails["totalCount"]).toLocaleString())),
                                                m('.detailReadUnread',
                                                    m('.detailRead', {
                                                        onclick: () => {
                                                            onTypeChanged('001');
                                                        }
                                                    }, this.getText("LT00000044", "Read")),
                                                    m('.detailUnread', {
                                                        onclick: () => {
                                                            onTypeChanged('002');
                                                        }
                                                    }, this.getText("LT00000045", "Unread")),
                                                    m('.clearFloat')
                                                ),
                                                m('.detailReadUnreadColor',
                                                    m('.detailReadColor', {
                                                        style: "font-size:" + countFont,
                                                        onclick: () => {
                                                            onTypeChanged('001');
                                                        }
                                                    }, Number(announcementDetails["readCount"]).toLocaleString()),
                                                    m('.detailUnreadColor', {
                                                        style: "font-size:" + countFont,
                                                        onclick: () => {
                                                            onTypeChanged('002');
                                                        }
                                                    }, Number(announcementDetails["unreadCount"]).toLocaleString()),
                                                    m('.clearFloat')
                                                )
                                            )
                                        ),
                                    )
                                ),
                                m('.col-3.d-flex.justify-content-center',
                                    m('.card',
                                        m('.card-body.pt-0.proPictureSize_holder',
                                            announcementDetails["photoString"] == '' && m('img.proPictureSize.mt-2[src="' + staticUrls.emptyUserImage + '"]'),
                                            announcementDetails["photoString"] != '' && m('img.proPictureSize.mt-2[src="' + announcementDetails["photoString"] + '"]'),
                                        )
                                    )
                                ),
                                m('.col.ps-0.d-flex',
                                    m('.card flex-grow-1',
                                        m('.card-body',
                                            m('.row',
                                                m('.col-sm-3',
                                                    m('p.font-weight-bold', { 'class': 'mb-0' }, 'Username'
                                                    )
                                                ),
                                                m('.col-sm-9',
                                                    m('p.mb-0', announcementDetails["userName"])
                                                ),
                                                m('hr.divider-line')
                                            ),
                                            m('.row',
                                                m('.col-sm-3',
                                                    m('p.font-weight-bold', { 'class': 'mb-0' }, 'Create Date'
                                                    )
                                                ),
                                                m('.col-sm-9',
                                                    m('p.mb-0', 'sent: ' + announcementDetails["createDate"])
                                                ),
                                                m('hr.divider-line')
                                            ),
                                            m('.row',
                                                m('.col-sm-3',
                                                    m('p.font-weight-bold', { 'class': 'mb-0' }, 'Role'
                                                    )
                                                ),
                                                m('.col-sm-9',
                                                    m('p.mb-0', announcementDetails["userRole"])
                                                ),
                                                m('hr.divider-line')
                                            ),
                                            m('.row',
                                                m('.col-sm-3',
                                                    m('p.font-weight-bold', { 'class': 'mb-0' }, this.getText("LT00000025", "Active"))
                                                ),
                                                m('.col-sm-9',
                                                    m('p.mb-0',
                                                        m('label.switcher',
                                                            m('input[type="checkbox"]',//[checked]',
                                                                {
                                                                    checked: isActive === "Y",
                                                                    onchange: e => {
                                                                        isActive = e.target.checked ? 'Y' : 'N';
                                                                        onStatusChange(isActive);
                                                                    }
                                                                }
                                                            ),
                                                            m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round')
                                                        )
                                                    )
                                                ),
                                            ),
                                        ),
                                    ),
                                )
                            )
                        )
                    )
                )
            ),
            m('.section-grey-bg px-2 py-3',
                m('.card',
                    m('.card-body',
                        m('h5', this.getText("LT00000056", "Content")),
                        m('textarea#txtContent.form-control.form-control-bg',
                            {
                                style: "height:120px",
                                disabled: true
                            },
                            announcementDetails["content"]
                        ),
                    )
                ),

                // m('h4', announcementDetails["content"]),
                m('.card',
                    m('.card-body',
                        m('h5', this.getText("LT00000047", "Attachments")),
                        m('hr'),
                        m('.row',
                            files.map(file =>
                                [
                                    m('.col-md-6',
                                        m('.form-check.form-check-inline',
                                            m('input.form-check-input[type="checkbox"]',
                                                {
                                                    checked: file.checked,
                                                    onchange: e => {
                                                        file.checked = e.target.checked
                                                    }
                                                }
                                            ),
                                            m('label.form-check-label', file.name)
                                        )
                                    )
                                ]
                            )

                        )
                    ),
                ),
                files.length > 0 && m('.d-flex.justify-content-end',
                    showCheckedAll && m('button.btn.btn-white', { onclick: _checkAll }, this.getText("LT00000054", "Check All")),
                    !showCheckedAll && m('button.btn.btn-white', { onclick: _unCheckAll }, this.getText("LT00000055", "Uncheck All")),
                    m('button.btn.btn-primary.ms-2', { onclick: _download }, "Download")
                ),
            ),
            m('.position-rel.mt-5',
                m('.position-abs', m('h4', this.getText("LT00000053", "Recipient List")),
                ),
                m(AnnouncementRecipientView, { detailType: detailType, announcementId: announcementId, statusSelectionNeed: 'N' })
            ),

            m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                , this.getBaseViews()];
        }
    }
}
